import { createContext } from "react";
import { IRecorderContext } from "../types";

export const RecorderContext = createContext<IRecorderContext>(null);
